<template>
    <div>
        <image-component :infoType="'banner'" :infoKey="`albumBanner`"></image-component>
        <div class="content">
            <div class="intro_tab" @click="movePage('vision')">비전</div>
            <div class="intro_tab active" @click="movePage('business')">주요사업</div>
            <div class="intro_tab" @click="movePage('info')">발자취</div>
            <div class="intro_tab" @click="movePage('financial')">재무보고</div>
            <div class="intro_tab" @click="movePage('support')">후원안내</div>
        </div>

        <div>
            <board-detail-component :boardType="`businessDetail`" :boardKey="boardKey"></board-detail-component>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import BoardDetailComponent from "@/components/board/BoardDetailComponent";
    import ImageComponent from "@/components/information/ImageComponent";

    export default {
        name: 'BusinessDetail',
        mixins: [],
        components: {BoardDetailComponent, ImageComponent},
        props: {},
        data() {
            return {
                boardKey: '',

            }
        },
        beforeRouterEnter() {
        },
        created() {
            this.getBoardKey()
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            getBoardKey() {
                this.boardKey = this.$route.params.wr_id
            },
            movePage(tab) {
                this.$router.push(`/intro?tab=${tab}`)
            }
        },
        watch: {},
    }
</script>
